/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
/* Buy it now diplay 시키기 */
/*
function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1000);
        setTimeout(fn, 2000);
        setTimeout(fn, 3000);
        setTimeout(fn, 4000);
        setTimeout(fn, 5000);
        setTimeout(fn, 6000);
        setTimeout(fn, 10000);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}   
docReady(function() {
    // DOM is loaded and ready for manipulation here

    var els = document.querySelectorAll(".shopify-payment-button");
    els.forEach(function(el) {
      el.style.display = 'block';
      //el.setAttribute('data-shopify','');
    });

    var els = document.querySelectorAll(".shopify-payment-button > div");
    els.forEach(function(el) {
      el.style.display = 'block';
    });  
});
*/
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */






/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
/* Buy it now diplay 시키기 */
function docReady(fn) {
  
  	//console.log(document.readyState);
  
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1000);
        setTimeout(fn, 2000);
      	//setTimeout(fn, 3000);
        setTimeout(fn, 4000);
      	setTimeout(fn, 5000);
        //setTimeout(fn, 6000);
        setTimeout(fn, 10000);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}   
docReady(function() {
    // DOM is loaded and ready for manipulation here
  
  	// 클래스명 강제 변경  	
	var els = document.querySelectorAll(".payment-buttons > .shopify-payment-button");
    els.forEach(function(el) {
      el.style.display = 'block';
      //el.setAttribute('class','shopify-payment-button shopify-payment-button-blocking');
      el.setAttribute('class','shopify-payment-button-blocking');
    });
  
    var els = document.querySelectorAll(".shopify-payment-button-blocking > div");
    els.forEach(function(el) {
      el.style.display = 'block';
    });
    
	var els = document.querySelectorAll(".shopify-payment-button-blocking");
    els.forEach(function(el) {
      el.style.display = 'block';
    });
  
});
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */










document.addEventListener("DOMContentLoaded", function(){
  
	// Handler when the DOM is fully loaded


	//const btns = document.querySelectorAll('dl.opn-toggle-wrapper > dt');
  	const btns = document.querySelectorAll('.opn-btn-toggle');
  
	btns.forEach(el => el.addEventListener('click', event => {
      
      //reset_faq_list();
      
      /* 
      var target =  event.target;
      alert(target.className);
      
      var toggle_wrap =  event.target.parentNode;
      alert(toggle_wrap.className);
      */
      
      var toggle_ctnt =  event.target.nextElementSibling;
      if (toggle_ctnt.classList.contains('hide')) {
        reset_faq_list();
        toggle_ctnt.classList.remove('hide');
      }
      else {
        toggle_ctnt.classList.add('hide');
      }

	}));
  
  
    function reset_faq_list() {
      //
      var els = document.querySelectorAll(".opn-toggle-wrap dd");
      els.forEach(function(el) {
        el.classList.add('hide');
      });
    }
  
  
  
  
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  
  	// 메인 Hero slide 링크 버튼 없애는 대신, 
    // 클릭했을 때만 링크 이동
    // 드래그 했을 때는 링크 이동 없음.
		
  	  let moved;
  	  let clicked;
      var elements = document.getElementsByClassName("click_hero_slideshow_2022");
      var downListener = function() {
          clicked = true;
       	  moved = false;
      };
      var hoverListener = function() {
      }
	  var moveListener = function() {
          moved = true;
      };
      var upListener = function() {
        if (moved == true) {
          //console.log('moved');
        } else {
          //console.log('not moved');
          var href = this.getAttribute("data-href");




          var els = elements;
          Array.prototype.forEach.call(els, function(element) {
              element.addEventListener("click", function(event) {
                
                //var href = event.target.getAttribute( 'href' );

                var ga_cate = '메인탑슬라이더';
                var ga_action = '[mainSlider]'+href;
                var ga_label = '[메인탑슬라이더]'+href;
                //console.log(ga_cate+','+ga_action+','+ga_label);


                //('send','event',ga_cate,ga_action,ga_label);
                try {
                  ga('send','event',ga_cate,ga_action,ga_label);
                } catch {
                }
                
              });
            });




          
          location.href = href;
        }
      };

      for (var i = 0; i < elements.length; i++) {
          elements[i].addEventListener("pointerdown", downListener, false);
          elements[i].addEventListener("pointermove", hoverListener, false);
          elements[i].addEventListener("pointermove", moveListener, false);
          elements[i].addEventListener("pointerup", upListener, false);
      }
  
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

                
                
                  
  // 팝업 자동 오픈
  //var popup = win_open('pages/popup-1', 'popup', 'left=600px,top=0px,width=455px,height=800px,scrollbars=0');
                
                
                
});






/* 팝업 기능 */
/*
            
// 팝업 열기
	function win_open(url, name, option) {
		var popup = window.open('/' + url, name, option);
		//popup.focus();
	}

// 팝업 닫기
	function popup_close(id, onday) {
		if (onday) {
			var today = new Date();
			today.setTime(today.getTime() + (60*60*1000*24));
			document.cookie = id + "=" + escape( true ) + "; path=/; expires=" + today.toGMTString() + ";";
		}

		if (window.parent.name.indexOf(id) != -1)
			window.close();
		else
			document.getElementById(id).style.display = 'none';
	}

// 페이지 이동
	function redirect(url) {
		document.location.href = url;
	}

*/


